import Axios from "axios";
import {
    SET_ASSET_MAINTENANCE_LIST,
    UNSET_ASSET_MAINTENANCE_LIST,
    SET_ASSET_REGISTER_MAINTENANCE_LIST,
    UNSET_ASSET_REGISTER_MAINTENANCE_LIST,
    SET_EDITING_ASSET_MAINTENANCE,
    UNSET_EDITING_ASSET_MAINTENANCE,
} from "@/store/mutation-types";

import { 
    saveUpdateAssetMaintenance, 
    getAssetMaintenanceList, 
    getAssetMaintenanceById, 
    getAssetRegisterMaintenancesList
} from "@/store/api";

const state = {
    getAssetMaintenanceList: [],
    getAssetRegisterMaintenancesList: [],
    getEditingAssetMaintenance: null,
};

const getters = {
    getAssetMaintenanceList(state) {
        return state.getAssetMaintenanceList;
    },
    getAssetRegisterMaintenancesList(state) {
        return state.getAssetRegisterMaintenancesList;
    },
    getEditingAssetMaintenance(state) {
        return state.getEditingAssetMaintenance;
    }
};

const mutations = {
    [SET_ASSET_MAINTENANCE_LIST](state, data) {
        state.getAssetMaintenanceList = data;
    },
    [UNSET_ASSET_MAINTENANCE_LIST](state) {
        state.getAssetMaintenanceList = [];
    },
    [SET_ASSET_REGISTER_MAINTENANCE_LIST](state, data) {
        state.getAssetRegisterMaintenancesList = data;
    },
    [UNSET_ASSET_REGISTER_MAINTENANCE_LIST](state) {
        state.getAssetRegisterMaintenancesList = [];
    },
    [SET_EDITING_ASSET_MAINTENANCE](state, data) {
        state.getEditingAssetMaintenance = data;
    },
    [UNSET_EDITING_ASSET_MAINTENANCE](state) {
        state.getEditingAssetMaintenance = null;
    }
};

const actions = {
    saveUpdateAssetMaintenance({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateAssetMaintenance, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getAssetMaintenanceList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetMaintenanceList, { params: data})
                .then(function (response) {
                    commit('SET_ASSET_MAINTENANCE_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_ASSET_MAINTENANCE_LIST')
                    reject(error);
                })
                .then((always) => {
                });
        });
    },

    getAssetRegisterMaintenancesList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetRegisterMaintenancesList, { params: data})
                .then(function (response) {
                    commit('SET_ASSET_REGISTER_MAINTENANCE_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_ASSET_REGISTER_MAINTENANCE_LIST')
                    reject(error);
                })
                .then((always) => {
                });
        });
    },

    getAssetMaintenanceById({ commit }, data) {
        const getAssetMaintenanceRecordById = `${getAssetMaintenanceById}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getAssetMaintenanceRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};


